import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/no-data.png'
import _imports_1 from '@/assets/images/package.png'


const _withScopeId = n => (_pushScopeId("data-v-3a584bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sbom-container" }
const _hoisted_2 = { class: "sbom-main" }
const _hoisted_3 = { class: "table-top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-title" }, " · 软件成分数据 ", -1))
const _hoisted_5 = { class: "query-list" }
const _hoisted_6 = { class: "query-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" License类型： ")
const _hoisted_8 = { class: "query-item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" License成分： ")
const _hoisted_10 = { class: "query-item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 漏洞级别： ")
const _hoisted_12 = { class: "query-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 是否精准查询： ")
const _hoisted_14 = {
  class: "query-item",
  style: {"width":"260px"}
}
const _hoisted_15 = { class: "sbom-table" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "暂无相关内容")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgIcon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgIcon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "txt" }
const _hoisted_21 = { class: "num" }
const _hoisted_22 = {
  key: 0,
  class: "cellBox"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "txt" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "txt" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_29 = { class: "sbom-pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_SbomVulnerabilityTable = _resolveComponent("SbomVulnerabilityTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_select, {
              modelValue: _ctx.licenseId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.licenseId) = $event)),
              clearable: "",
              filterable: "",
              placeholder: "请选择",
              onChange: _ctx.search
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenseIds, (item, itemIndex) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: itemIndex,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_el_select, {
              modelValue: _ctx.licenseType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.licenseType) = $event)),
              clearable: "",
              placeholder: "请选择",
              onChange: _ctx.search
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenseList, (item, itemIndex) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: itemIndex,
                    label: item.label,
                    value: item.prop
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_el_select, {
              modelValue: _ctx.vulSeverity,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vulSeverity) = $event)),
              clearable: "",
              placeholder: "请选择",
              onChange: _ctx.search
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vulSeverityList, (item, itemIndex) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: itemIndex,
                    label: item.label,
                    value: item.prop
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_switch, {
              modelValue: _ctx.isExactly,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isExactly) = $event)),
              onChange: _ctx.retrievePackages,
              "inline-prompt": "",
              "active-text": "是",
              "inactive-text": "否"
            }, null, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.packageName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.packageName) = $event)),
              placeholder: "输入package名称，按enter键搜索",
              "prefix-icon": _ctx.Search,
              onKeyup: _withKeys(_ctx.search, ["enter"])
            }, null, 8, ["modelValue", "prefix-icon", "onKeyup"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_table, {
          ref: "singleTableRef",
          data: _ctx.pageData,
          border: "",
          "highlight-current-row": "",
          "max-height": "100%"
        }, {
          empty: _withCtx(() => [
            _hoisted_16
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              fixed: "",
              type: "index",
              label: "编号",
              width: "70",
              index: _ctx.indexCounter
            }, null, 8, ["index"]),
            _createVNode(_component_el_table_column, {
              fixed: "",
              property: "name",
              label: "软件包名称",
              width: "250",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(scope.row.name), 1)
              ]),
              _: 1
            }),
            (_ctx.IsOpenEulerByProductName())
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  property: "version",
                  label: "版本(epoch:version-release)",
                  width: "250",
                  "show-overflow-tooltip": ""
                }))
              : (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  property: "version",
                  label: "版本",
                  "show-overflow-tooltip": "",
                  width: "250"
                }, {
                  default: _withCtx((scope) => [
                    _hoisted_18,
                    _createElementVNode("span", null, _toDisplayString(scope.row.version), 1)
                  ]),
                  _: 1
                })),
            _createVNode(_component_el_table_column, {
              property: "licenseConcluded",
              label: "漏洞风险数值",
              width: "550"
            }, {
              default: _withCtx((scope) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vluProps, (vul, vulIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: vulIndex }, [
                    (scope.row.statistics && (scope.row.statistics[vul.prop] || scope.row.statistics[vul.prop]===0))
                      ? (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass([
						  'vulBtns',
						  'vul'+vulIndex,
						  { vulZero: scope.row.statistics[vul.prop] === 0 }
					  ]),
                          key: vulIndex,
                          onClick: ($event: any) => (_ctx.openVulnDialog(scope.row, vul, scope.row.statistics[vul.prop]))
                        }, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(vul.label), 1),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(scope.row.statistics[vul.prop]), 1)
                        ], 10, _hoisted_19))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              property: "licenseConcluded",
              label: "License",
              "min-width": "200",
              formatter: _ctx.NoAssertionFormat
            }, {
              default: _withCtx((scope) => [
                (scope.row.licenses && scope.row.licenses.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.licenses, (license, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (license.licenseName)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                effect: "dark",
                                content: license.licenseName,
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["licenseItem", { canClick: license.licenseUrl}]),
                                    onClick: ($event: any) => (_ctx.goPath(license))
                                  }, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['dot', license.legal ? 'green' : 'red'])
                                    }, null, 2),
                                    _createElementVNode("span", _hoisted_24, _toDisplayString(license.licenseId), 1)
                                  ], 10, _hoisted_23)
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(["licenseItem", { canClick: license.licenseUrl}]),
                                onClick: ($event: any) => (_ctx.goPath(license))
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['dot', license.legal ? 'green' : 'red'])
                                }, null, 2),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(license.licenseId), 1)
                              ], 10, _hoisted_25))
                        ], 64))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, "--"))
              ]),
              _: 1
            }, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              property: "supplier",
              label: "Supplier",
              "min-width": "200",
              "show-overflow-tooltip": "",
              formatter: _ctx.NoAssertionFormat
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              fixed: "right",
              width: "100",
              label: "更多"
            }, {
              default: _withCtx((props) => [
                _createVNode(_component_router_link, {
                  to: '/sbomPackageDetail/' + props.row.id + '/' + _ctx.isOpenEuler + '?productName=' + _ctx.getProductName,
                  target: "_blank",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_el_pagination, {
            layout: "total, sizes, prev, pager, next, jumper",
            "page-sizes": [10, 15, 20, 25, 30],
            total: _ctx.totalElements,
            "page-size": _ctx.pageSize,
            "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageSize) = $event)),
            currentPage: _ctx.pageNum,
            "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
            onCurrentChange: _ctx.handlePageChange,
            onSizeChange: _ctx.handleSizeChange
          }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "漏洞详情列表",
      modelValue: _ctx.showVulnDialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showVulnDialog) = $event)),
      "close-on-click-modal": false,
      width: "80%",
      "custom-class": "sbom-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SbomVulnerabilityTable, {
          productName: _ctx.getProductName,
          severity: _ctx.vulnSeverity,
          packageId: _ctx.packageId,
          isByProductName: ""
        }, null, 8, ["productName", "severity", "packageId"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}